// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PageContainer, PageHeader } from "../components/AssetBreadCrumb";
import { PageBackButton } from "../components/PageChrome";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "../components/Skeleton";
import {
  fetchMyPublicProfile,
  createMyPublicProfile,
  updateMyPublicProfile,
} from "../store/publicProfileSlice";
import PublicProfileEditor, { buildPublicProfileInput } from "../components/PublicProfile/PublicProfileEditor";

const ManagePublicProfilePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { myProfile, myProfileLoaded } = useSelector((state) => state.publicProfile);

  const userId = user?.permissionDetails?.id;
  const [savingUser, setSavingUser] = useState(false);
  const [saveError, setSaveError] = useState(null);

  useEffect(() => {
    if (userId) dispatch(fetchMyPublicProfile(userId));
  }, [dispatch, userId]);

  const handleSaveUser = async (values, toggles) => {
    if (!userId) return;
    setSavingUser(true);
    setSaveError(null);
    try {
      const input = buildPublicProfileInput(userId, values, toggles);
      await dispatch(myProfile ? updateMyPublicProfile(input) : createMyPublicProfile(input)).unwrap();
    } catch (e) {
      console.error("Failed to save public profile", e);
      setSaveError("Couldn't save your profile. Please try again.");
    } finally {
      setSavingUser(false);
    }
  };

  const userDefaults = {
    displayName: user?.permissionDetails?.name || "",
    email: user?.permissionDetails?.email || "",
    profilePictureUrl: user?.permissionDetails?.profilePictureUrl || "",
  };

  return (
    <PageContainer>
      {/* Same column as Settings, so moving between them doesn't shift the measure */}
      <div className="mx-auto w-full max-w-3xl">
        <PageHeader
          eyebrow="Settings"
          title="Public Profile"
          description="Control what people see when you author a model. Hidden fields are removed from your public record, not just hidden here."
          action={
            <PageBackButton label="Back to Settings" onClick={() => navigate("/home/settings")} />
          }
        />

        {!myProfileLoaded ? (
          <div className="eai-panel">
            <Skeleton className="h-5 w-48" radius="md" />
            <Skeleton className="mt-2 h-3.5 w-72" />
            <div className="mt-5 flex flex-col gap-4">
              <Skeleton className="h-eai-control-lg w-full" radius="md" />
              <Skeleton className="h-eai-control-lg w-full" radius="md" />
              <Skeleton className="h-24 w-full" radius="md" />
            </div>
          </div>
        ) : (
          <>
            {!myProfile && (
              <div className="mb-5 rounded-eai-card border border-eai-border bg-eai-surface-sunken p-4 font-inter text-eai-body-sm text-eai-info-text">
                You currently have no public facing profile. Fill in the details below to create one.
              </div>
            )}
            <PublicProfileEditor
              title="Your public profile"
              subtitle="Shown when you are credited as the author of a model."
              profile={myProfile}
              defaults={userDefaults}
              saving={savingUser}
              onSave={handleSaveUser}
              error={saveError}
              id={userId}
              uploadFolder="publicProfile"
              lockedFields={["displayName", "email"]}
            />
          </>
        )}
      </div>
    </PageContainer>
  );
};

export default ManagePublicProfilePage;
